<template>
	<div class='art-item art-item3 ahx0'>
		<common-top :commonTopData="commonTopData"></common-top>
        <div class="ahx">
            <div class="feature">
				<el-button class="feature-item add" type="primary" size="small" icon="el-icon-plus" @click="showCom('addPages',{channel:tableConfig.pr.channel})">添加页面</el-button>
				<el-button class="feature-item add" type="primary" size="small" @click="go()">返回</el-button>
				
			</div>
            <comTable :config="tableConfig" ref="table1"></comTable>
        </div>	
        <component @closeFn="close" v-model="componentData" v-bind:is="componentName"></component>
	</div>
</template>

<script>
import commonTop from '@/components/commonTop.vue'
import comTable from '@/components/comTable.vue'
import addPages from './addPages.vue'
export default {
	components: {
		commonTop,
		comTable,
        addPages
	},
	data () {
		// 这里存放数据
		return {
            componentName:'',
            componentData:{},
            commonTopData: {
				"commonleftbtn": [],
			},
			tableConfig:{
				url:'quickerChannelPageList',
				pr:{},
				list:[
					{label:'页面',prop:'page_id'},
					{label:'页面名称',prop:'page_name'},
					{label:'创建时间',prop:'create_at'},
					{label:'操作',type:'tool',btns:[
						
						{label:'编辑',clickFn:da=>{
							this.showCom('addPages',da)
						}},
						{label:'运营管理',clickFn:da=>{
							this.$router.push({
								path:'item-pages-cont',
								query:{
									channel:da.channel,
									page_id:da.page_id
								}
							})
						}},
					]},
					
				]
			},
		

			addLoading: false,
		}
	},
    created(){
        if(!this.$route.query.channel){
            this.$router.back(-1)
        }
		this.tableConfig.pr = {
			channel:this.$route.query.channel
		}
    },
	mounted () {

	},

	methods: {
		go(){
			this.$router.push('/art/item-channel')
		},
        showCom(n,a){
            this.componentName = n;
            this.componentData = a || {}
        },
        close(n){
            this.showCom('')
            if(n=='sx'){
                this.$refs.table1.getData();
            }
        },
	}
}
</script>
<style >
.ahx0{
	height: 100%;
}
.ahx{
	height: calc(100% - 60px);
}
</style>